export interface UpdateMyProjectOptimisticSource {
  id: string;
  name?: string | null;
  curation_rating?: string | null;
  transcription_url?: string | null;
  speaker_layout?: number | null;
  post_layout?: unknown;
  subtitle_config?: unknown;
  brand_kit?: { id: string; name: string } | null;
}

export interface UpdateMyProjectOptimisticPatch {
  speaker_layout?: number | null;
  post_layout?: unknown;
  subtitle_config?: unknown;
}

/** Optimistic payload for `updateMyProject`. Must cover every field in the
 *  mutation selection set or Apollo throws while writing the cache. */
export function buildUpdateMyProjectOptimistic(
  project: UpdateMyProjectOptimisticSource,
  patch: UpdateMyProjectOptimisticPatch = {},
) {
  return {
    updateMyProject: {
      __typename: 'MyProject' as const,
      id: project.id,
      name: project.name ?? '',
      curation_rating: project.curation_rating ?? null,
      transcription_url: project.transcription_url ?? null,
      speaker_layout: patch.speaker_layout !== undefined
        ? patch.speaker_layout
        : project.speaker_layout ?? null,
      post_layout: 'post_layout' in patch ? patch.post_layout ?? null : project.post_layout ?? null,
      subtitle_config: 'subtitle_config' in patch
        ? patch.subtitle_config ?? null
        : project.subtitle_config ?? null,
      brand_kit: project.brand_kit
        ? {
            __typename: 'MyProjectBrandKit' as const,
            id: project.brand_kit.id,
            name: project.brand_kit.name,
          }
        : null,
    },
  };
}
